<template>
  <div :data-test="`recruiter-tags-${rowIndex}`">
    <WdsTagGroup :tags="formattedTags" sm :max-tags="3" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTagGroup } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const CompanyRecruiterTagsColumn = graphql(`
  fragment CompanyRecruiterTagsColumn on CompanyRecruiter {
    tags {
      id
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof CompanyRecruiterTagsColumn>
  rowIndex?: number
}>()
const column = computed(() => useFragment(CompanyRecruiterTagsColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

const formattedTags = computed(() =>
  column.value.tags.map((tag) => ({
    label: tag.name ?? '',
    primary: false,
  })),
)
</script>
